import HeroFooter from "../heroFooter/HeroFooter";
import heroImg from "../../../assets/Gemini_Generated_Image_fenpfkfenpfkfenp.png";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
// import bannerImg from "../../../assets/banner.webp";

function Hero() {
  // Hook for translation
  const { t } = useTranslation();

  return (
    <>
      <div
          className="w-full relative bg-cover bg-center [mask-image:linear-gradient(to_bottom,rgba(0,0,0,1)_70%,rgba(0,0,0,0)_100%)] -webkit-[mask-image:linear-gradient(to_bottom,rgba(0,0,0,1)_70%,rgba(0,0,0,0)_100%)]"
          style={{ backgroundImage: `url(${heroImg})` }}
      >
          {/* Dein restlicher Inhalt (Texte, Buttons etc.) */}
        
      

        <div className="project-container relative pt-32 pb-24 md:pt-48 md:pb-40 flex flex-col items-center text-center">
          <h1 className="xl:text-[62px] xl:leading-[135%] md:text-5xl text-4xl font-bold text-black max-w-4xl">
            {t("bannerHeading")}
          </h1>

          <div className="mt-8 max-w-2xl">
            <p className="text-lg md:text-xl font-medium text-black/90 leading-relaxed">
              {t("bannerSubheading")}
            </p>
          </div>

          <div className="mt-10 flex flex-col md:flex-row justify-center gap-4 md:gap-5">
            {/* Hauptbutton (Lila) */}
            <a href="/demo">
              <button className="w-max px-8 py-3 rounded-[20px] bg-gradient-to-r from-[#B588FF] to-[#8B5FFF] text-white font-semibold transform transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:from-[#A576FF] hover:to-[#7A4EFF] active:scale-95 focus:outline-none focus:ring-4 focus:ring-purple-300">
                {t("bannerButton")}
              </button>
            </a>
            
            {/* Zweiter Button (Schwarz -> Weiß) */}
            <a href="https://calendly.com/jochen-sagert/jobdaten" target="_blank" rel="noopener noreferrer">
              <button className="w-max px-8 py-3 rounded-[20px] bg-black text-white border border-black font-semibold transform transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:bg-white hover:text-black active:scale-95 focus:outline-none focus:ring-4 focus:ring-gray-300">
                {t("bannerButtonTwo")}
              </button>
            </a>
          </div>
        </div>
      </div>

      {/* Footer */}
      <HeroFooter />
    </>
  );
}

export default Hero;
